__webpack_require__.p = "/reliedu-vocab/";